const Footer = (): JSX.Element => null

export default Footer
